App.DishEditController = Em.Controller.extend
  session: Em.inject.service()

  env: Em.inject.service('environment')

  needs: [ 'categories', 'category', 'modifierGroupsIndex' ]

  categoriesBinding: 'controllers.categories.model'
  categoryBinding: 'controllers.category.model'
  restaurantsBinding: 'controllers.categories.restaurants'
  dishesBinding:   'controllers.category.dishes'
  cookingLinesBinding:   'controllers.category.cooking_lines'
  modifierGroupsBinding: 'controllers.category.modifierGroups'

  weightUnits: ['gram', 'kilogram', 'milliliter', 'liter']
  exciseUnits: [
    'commodity', 'excise', 'service', 'excise_with_label', 'excise_without_label',
    'commodity_with_label', 'commodity_without_label', 'other'
  ]

  sources: ['delivery_club', 'foodfox', 'broniboy', 'obed_ru', 'chibbis', 'glovo', 'vk', 'sbermarket']

  canEditMenu: Em.computed.alias('controllers.category.canEditMenu')
  cantEditMenu: Em.computed.alias('controllers.category.cantEditMenu')

  canEditRestaurantPrices: Em.computed.alias('session.accessRights.restaurantPricesEdit')
  cantEditRestaurantPrices: Em.computed.not('canEditRestaurantPrices')

  canSaveDish: Em.computed.or('canEditMenu', 'canEditRestaurantPrices')
  canDeleteDish:  Em.computed('canEditMenu', 'dish.isNew', ->
    @get('canEditMenu') and !@get('dish.isNew')
  )

  currentTab: 'advancedTab'
  isConfiguratorTab: Em.computed.equal('currentTab', 'configuratorTab')
  isPricesTab: Em.computed.equal('currentTab', 'pricesTab')
  isAdvancedTab: Em.computed.equal('currentTab', 'advancedTab')

  photoCurrentTab: 'mainTab'
  isPhotoMainTab: Em.computed.equal('photoCurrentTab', 'mainTab')
  isPhotoAdditionalTab: Em.computed.equal('photoCurrentTab', 'additionalTab')

  isLoading: false


  showMetricSettings:(->
    @get('env.features.enableMetricDishes')
  ).property('env.features.enableMetricDishes')

  setMetricWeight:(->
    if @get('dish.metric')
      @get('dish').set('weight', '')
  ).observes('dish.metric')

  currencyText: (->
    currencyLabel = Em.I18n.t('dish_edit.form.price.label')
    weightCurrencyLabel = Em.I18n.t('dish_edit.form.weight_price.label', unit: Em.I18n.t("draft_dish.weight_units_short.#{@get('dish.price_weight_unit')}"))
    unless @get('dish.metric') then "#{currencyLabel}(#{@get('currencyUnit')})" else weightCurrencyLabel
  ).property('dish.metric', 'dish.price_weight_unit')

  qtyText: (->
    unit = @get('dish.weight_unit')
    path = if unit in ['kilogram', 'gram'] then 'weight' else 'volume'
    Em.I18n.t("dish_edit.form.min_qty.#{path}", unit: Em.I18n.t("draft_dish.weight_units_short.#{@get('dish.weight_unit')}"))
  ).property('dish.weight_unit')

  deltaQtyText: (->
    unit = @get('dish.weight_unit')
    path = if unit in ['kilogram', 'gram'] then 'weight' else 'volume'
    Em.I18n.t("dish_edit.form.delta_qty.#{path}", unit: Em.I18n.t("draft_dish.weight_units_short.#{@get('dish.weight_unit')}"))
  ).property('dish.weight_unit')

  canEditConfigurator:  Em.computed(
    'canEditMenu',
    'dish.has_modifier_scheme',
    ->
      @get('canEditMenu') and !@get('dish.has_modifier_scheme')
  )

  canEditBonusOnlyToggle: Em.computed.bool('env.features.bonusOnlyDishesEnabled')

  cantEditConfigurator: Em.computed.not('canEditConfigurator')

  isSaving: false
  settingCustomRestaurantPrice: false



  # Хеш с сообщениями валидации для полей модели
  validations: {}

  weightUnitsLabeled: ( ->
    @get('weightUnits').map (m) ->
      {
        id:   m,
        name: Em.I18n.t("draft_dish.weight_units." + m)
      }
  ).property('weightUnits')

  exciseUnitsLabeled: ( ->
    @get('exciseUnits').map (unit) ->
      {
        id:   unit,
        name: Em.I18n.t("draft_dish.excise_units.#{unit}")
      }
  ).property('exciseUnits')


  VALIDATABLE_FIELDS: [
    'suggest_priority'
  ]

  # ---
  # Извлекает сообщения валидации из модели в объект
  # можно вынести в миксин
  # ---
  extractValidations: (model, fields) ->
    errors = model.get('errors')
    validations = {}

    fields.forEach (field) =>
      if errors.has(field)
        validations[field] = errors.errorsFor(field).map (m) ->
          m.message
        .join(',')

    errors.clear()
    validations



  dishBinding: 'model'

  currencyUnit: Em.computed.alias('session.currency.unit')

  hasCustomRestaurantPrice: ( ->
    @get('dish.restaurant_prices').filter((rp) -> rp.price || rp.is_hidden).length > 0
  ).property('dish.restaurant_prices.[]')

  filteredRestaurantsPrices: (->
    regionalAdmin = @get('session.currentUser.account.isRegionalAdmin')
    userRestaurants = @get('session.currentUser.account.restaurants')
    prices = @get('dish.restaurant_prices')

    return @get('dish.sortedRestaurantPrices') unless regionalAdmin

    prices.filter((price) -> userRestaurants.some((restaurant) -> restaurant.get('id') == price.get('restaurant.id')))

  ).property('dish.restaurant_prices.[]')

  checkRestaurantsInPrices: ( ->
    return unless @get('showCustomRestaurantPrice')
    prices = @get('dish.restaurant_prices')
    has = prices.map (rp) -> rp.get('restaurant.id')
    @get('restaurants').forEach (r) =>
      if has.indexOf(r.get('id')) == -1
        @get('store').createRecord 'restaurant_price', restaurant: r , draft_dish: @get('dish'), options: @get('dish.options'), price: null, is_hidden: false

  ).observes('dish.id', 'settingCustomRestaurantPrice')

  showCustomRestaurantPrice: Em.computed.or('hasCustomRestaurantPrice', 'settingCustomRestaurantPrice')

  enabledCustomRestaurantPrice:  Em.computed.alias('dish.organization.features.dish_restaurant_prices')
  enabledMultiplePhotos:         Em.computed.alias('dish.organization.features.enable_dish_alternative_media')
  enabledDishSuggesting:         Em.computed.alias('dish.organization.features.dish_sugggesting_enabled')
  enabledCookingTime:            Em.computed.alias('dish.organization.features.cooking_time_auto')
  enableDishAdditionalParams:    Em.computed.alias('dish.organization.features.board_show_dish_additional_attributes')
  enabledRequiredDishes:         Em.computed.alias('dish.organization.features.required_dishes')

  enableAdditionalTabs: (->
    @get('enableDishAdditionalParams') or @get('enabledCustomRestaurantPrice') or @get('canEditMenu')
  ).property('enabledCustomRestaurantPrice', 'enableDishAdditionalParams')

  showSuggestingField: (->
    @get('dish.suggest_priority') > 0 || @get('isSuggestingEditing')
  ).property('dish.suggest_priority', 'isSuggestingEditing')

  dishAttributes: (->
    @get('dish.organization.dish_attributes')
  ).property('dish.organization.dish_attributes')

  fadeSuggestingField: (->
    if @get('dish.suggest_priority') == ''
      Em.run.later =>
        @set('isSuggestingEditing', false) if @get('dish.suggest_priority') == ''
      , 4000
    else
      @set('isSuggestingEditing', true)
  ).observes('dish.suggest_priority')

  saveDish: ->
    new Em.RSVP.Promise (resolve, reject) =>
      return reject() if @get('isSaving')

      @set('isSaving', true)

      dish = @get('dish')

      dish.normalizeConfigurator()

      dish.save()
      .then =>
        dish.reload().then(resolve)
      .catch =>
        false
      .finally =>
        @set('validations', @extractValidations(dish, @VALIDATABLE_FIELDS))

        @get('dish.restaurant_prices').map((a) -> a).forEach (rp) ->
          rp.destroyRecord() unless rp.get('id')

        if @get('dish.modifier_scheme.modifier_scheme_items')
          @get('dish.modifier_scheme.modifier_scheme_items').map((a) -> a).forEach (ms) ->
            ms.destroyRecord() unless ms.get('id')

        @set('isSaving', false)

  actions:
    setRestaurantPrice: (restaurant_price) ->
      restaurant_price.set('price', @get('dish.price') || '0')

    setCustomRestaurantPrice: ->
      @set('settingCustomRestaurantPrice', true)

    addDisabledSource: (source)->
      v = @get('dish.disabled_sources_array').map((x) => x)
      v.push source
      @get('dish').set('disabled_sources_array', v)

    removeDisabledSource: (source)->
      v = @get('dish').get('disabled_sources_array')
      v = v.filter (s) =>
        s != source
      @get('dish').set('disabled_sources_array', v)

    toggleSuggesting: ->
      @get('dish').set('suggest_priority', if @get('showSuggestingField') then 0 else 1)
      Em.run.next(=> Em.$('input.suggest-priority').focus())


    setCustomRestaurantPriceOff: ->
      @get('dish.restaurant_prices').map((a) -> a).forEach (rp) ->
        rp.set('price', null)
        rp.set('is_hidden', false)

      @set('settingCustomRestaurantPrice', false)

    wouldUploadPhoto: (permission) ->
      dish = @get('dish')
      return permission.resolve() unless dish.get('isNew')

      # todo i18n
      if confirm 'Необходимо сохранить блюдо перед загрузкой фотографии. Сохранить?'
        @saveDish().then =>
          permission.resolve()
        , =>
          permission.reject()
      else
        permission.reject()
      false

    delete: ->
      # todo i18n
      if confirm 'Удалить блюдо?'
        dish = @get('dish')

        dish.destroyRecord()
        .then =>
          @get('dishes').removeObject(dish)
          @transitionToRoute('category', @get('category'))
      false

    acceptChanges: ->
      @saveDish().then =>
        @transitionToRoute('category', @get('category'))
      false

    discardChanges: ->
      # Из-за бага в ember-data, rollback не возвращает категорию из model.data, присваеваем старую категорию вручную
      @get('dish').set('draft_category', @get('category'))

      @get('dish').rollback()
      @transitionToRoute('category', @get('category'))
      false

    changeLoadingState: (state) ->
      console.log state
      @set('isLoading', state)
